var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var FETCH_DOCUMENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query FetchDocument($electionEventId: String, $documentId: String!) {\n        fetchDocument(election_event_id: $electionEventId, document_id: $documentId) {\n            url\n        }\n    }\n"], ["\n    query FetchDocument($electionEventId: String, $documentId: String!) {\n        fetchDocument(election_event_id: $electionEventId, document_id: $documentId) {\n            url\n        }\n    }\n"])));
var templateObject_1;
